import React from 'react';
import { useItems } from '../../hooks/atoms/items-hook';
import AppDropdownButton from '../basic/AppDropdownButton';

function ItemsDropdownButton(
  {
    collection,
    title,
    defaultvalue,
    onChange,
    disabled,
    required = false,
    color = undefined,
  },
) {
  const {
    items: data,
    itemsLoading: isLoading,
  } = useItems(collection, { filterQuery: { _limit: -1 } });

  return (
    <AppDropdownButton
      title={ title }
      color={ color }
      value={ defaultvalue }
      onChange={ onChange }
      disabled={ !!disabled }
      options={ data }
      loading={ isLoading }
      required={ required }
    />
  );
}

export default ItemsDropdownButton;
